const locale = {
    placeholder: 'בחר שעה',
    rangePlaceholder: ['שעת התחלה', 'שעת סיום'],
};
export default locale;
